import React, {Fragment, useCallback, useEffect, useMemo, useState} from "react";
import {
    CustomDropdownButton,
    CustomHeader,
    CustomTableRow,
    CustomTD, Dot,
    RequiredItemsBadge,
    StyledTable,
    StyledTableHeaderCell
} from "@pages/new-design-components/custom-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import {Dropdown, DropdownItem, DropdownMenu, Modal} from "reactstrap";
import {API_URL, checkAndFormatShortGb, parseToWord} from "@constants/index";
import Picker from "@pages/components/DatePicker";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import MessagingComponent from "@pages/components/DebtManagement/MessagingComponent";
import {GET_COMMUNICATION_LOGS_REQUEST, SEND_SMS_REQUEST} from "@redux/Customer/actions";
import usePrevious from "@hooks/useprevious";
import notify from "@utils/notify";
import EmailChat from "@pages/components/DebtManagement/EmailChat";
import axios from "axios";
import SendQuoteEmail from "@pages/components/DebtManagement/SendQuoteEmail";
import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import {array} from "prop-types";

export default function CommunicationsLog({
                                              customer,
                                              profileDataId,
                                              systemTemplates
                                          }) {
    const {
        communicationLogs,
        sendSmsError,
        sendSmsSuccess,
        getCommunicationLogsSuccess,
        getCommunicationLogsError,
    } = useSelector((state) => state.customer, shallowEqual);
    const dispatch = useDispatch();
    useEffect(()=>{
        fetchCommunicationLogs()
    },[])
    const [loading,setLoading] = useState(true);
    const sendSmsSuccessPrev = usePrevious(sendSmsSuccess);
    const sendSmsErrorPrev = usePrevious(sendSmsError);

    const getCommunicationLogsSuccessPrev = usePrevious(getCommunicationLogsSuccess);
    const getCommunicationLogsErrorPrev = usePrevious(getCommunicationLogsError);

    const [templateData,setTemplateData] = useState({});
    const [openEmailChat,setOpenEmailChat] = useState(false);
    const [openSentQuoteEmail,setOpenSentQuoteEmail] = useState(false);

    const [filter,setFilter] = useState({
        from: '',
        to: ''
    });

    useEffect(()=>{
        if (getCommunicationLogsSuccess && getCommunicationLogsSuccessPrev === false) {
            setLoading(false)
        }
    },[getCommunicationLogsSuccessPrev,getCommunicationLogsSuccess])

    useEffect(()=>{
        if (getCommunicationLogsError && getCommunicationLogsErrorPrev === false) {
            setLoading(false)
            notify.warning('Something went wrong please try again later!');
        }
    },[getCommunicationLogsErrorPrev,getCommunicationLogsError])
    const fetchCommunicationLogs = (tempFilter = {}) => {
        dispatch({
            type: GET_COMMUNICATION_LOGS_REQUEST,
            payload: { id: customer.id, type: 'Customer', ...tempFilter }
        });
    }
    const updateFilter = ({key,value}) => {
        let overviewTemp = {...filter}
        overviewTemp[key] = value
        setFilter(overviewTemp)
        fetchCommunicationLogs(overviewTemp)
    }


    useEffect(()=>{
        if (sendSmsSuccess && sendSmsSuccessPrev === false) {
            notify.info('Sending is in process!');
        }
    },[sendSmsSuccess,sendSmsSuccessPrev])

    useEffect(()=>{
        if (sendSmsError && sendSmsErrorPrev === false) {
            notify.warning('Something went wrong');
        }
    },[sendSmsError,sendSmsErrorPrev])

    const transformData = (data) => {
        setTemplateData(data.data)
        setOpenEmailChat(false)
        setOpenSentQuoteEmail(true)
    }


    const tabs = [
        {
            key: 'all',
            label: 'All',
        },
        {
            key: 'ProcessedEmail',
            label: 'Email',
        },
        {
            key: 'SmsProcess',
            label: 'Text',
        },
    ]
    const [activeCommunicationTab, setActiveCommunicationTab] = useState('all');

    const tableData = useMemo(()=>{
        if (activeCommunicationTab === 'all') {
            return communicationLogs
        } else {
            return  communicationLogs.filter(note=>note.source_type === activeCommunicationTab)
        }
    },[activeCommunicationTab,communicationLogs])

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [openMessaging,setOpenMessaging] = useState(false);
    const [showMessageModal,setShowMessageModal] = useState(false);
    const [activeMessage,setActiveMessage] = useState(null);
    const [error,setError] = useState({
        message: {
            show: false,
            message: ''
        }
    });
    const openNewMessage = () => {
        setOpenMessaging(true)
    }
    const toggleMessageModal = () => {
        setShowMessageModal(!showMessageModal);
    }
    const showMessage = (idx) => {
        setActiveMessage(tableData[idx].source.message)
        toggleMessageModal()
    }
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const keys = [
        {
            key: 'created_at',
            label: 'Date'
        } ,
        {
            key: 'source_type',
            label: 'Type'
        } ,
        {
            key: 'recipient',
            label: 'Recipient'
        },
        {
            key: 'outreach_part',
            label: 'Outreach Party'
        },
        {
            key: 'representative',
            label: 'Representative'
        },
        {
            key: 'event_type',
            label: 'Status'
        },
        {
            key: 'view',
            label: 'View'
        },
    ]
    const generateItem = ({item,index,key,itemIndex}) => {

         if (key === 'source_type') {
            return <CustomTD key={index}>
                {
                    item?.source_type === 'SmsProcess' ?
                        <IcoMoon
                            className={'cursor-pointer email-icon'}
                            iconSet={IconSet}
                            icon={ 'ic_message'}
                            size={20}
                        /> :
                        <IcoMoon
                            className={'cursor-pointer department-icon'}
                            iconSet={IconSet}
                            icon={ 're_email'}
                            size={20}
                        />
                }

            </CustomTD>
        } else if (key === 'outreach_part') {
            return <CustomTD key={index}>
                {   item?.source_type === 'SmsProcess' ?
                    `+${item.source?.noteable?.mobile_number}` :
                    item.source?.noteable?.length && item.source?.noteable[0]?.email_address
                }
            </CustomTD>
        } else if (key === 'recipient') {
            return <CustomTD key={index}>
                {item.source?.creator?.email}
            </CustomTD>
        }  else if (key === 'created_at') {
            let value = parseToWord(item[key]?.toString())
            return <CustomTD key={index}>{checkAndFormatShortGb(value)}</CustomTD>
        } else if (key === 'representative') {
             return <CustomTD key={index}>
                 {   customer?.full_name }
             </CustomTD>
         } else if (key === 'event_type') {
            return <CustomTD key={index}>
                {item.source?.latest_event?.event_type || item.source?.status}
            </CustomTD>
        } else if (key === 'view') {
             return <CustomTD key={index} color={'#467bea'} onClick={()=>{showMessage(itemIndex)}} className={'cursor-pointer'}>View</CustomTD>
         }
        return <CustomTD key={index}>
            {item[key] ? item[key] : '-'}
        </CustomTD>
    }
    const sendSms = (newMessage) => {
        let obj = {
            'creator_id': profileDataId,
            'creator_type': 'User',
            'message': newMessage,
            'phone': `+${customer.mobile_number}`,
            'customerId': customer.id,
        }
        if (customer.deals.length) {
            obj['dealId'] = customer.deals[0].id;
        }
        dispatch({
            type: SEND_SMS_REQUEST,
            payload: obj
        });
    }
    function sendEmail({data}) {
        let formData = new FormData();
        formData.append('message',data?.message);
        formData.append('subject',data?.subject);
        formData.append('write_log',true);
        formData.append('to[]',data.email);
        if (customer.deals.length) {
            formData.append('dealId', customer.deals[0].id);
        } else {
            formData.append('customerId', customer.id);
        }
        if (data.hasOwnProperty('documents') && data.documents.length) {
            for (const document of data?.documents) {
                if (document.file) {
                    formData.append('fileLists[]', document.file);
                }
            }
        }

        formData.append('resource_id',customer.id);
        formData.append('resource_type','Customer');
        axios({
            method: 'POST',
            url: API_URL + '/processor-emails',
            headers: {
                'content-type': 'multipart/form-data',
            },
            data: formData
        }).then(res=>{
            notify.success('Success!', 'Sent successfully');
            console.log('res:',res)
        }).catch(err=>{
            notify.warning('Something went wrong');
            console.log('err:',err)
        })

    }

    return (
        loading ?
            <LoaderContainer>
                <ClipLoader
                    css={override}
                    size={40}
                    color={`#7B61E4`}
                    loading={loading}
                />
            </LoaderContainer> :
            <>
                <Modal isOpen={showMessageModal}
                       toggle={toggleMessageModal}
                       className={'modal-dialog-centered'}
                >
                    <div className={'p-3'}>
                        <h6 className="modal-title text-center">Message</h6>
                    </div>
                    <div className={'modal-body'} dangerouslySetInnerHTML={{ __html:  activeMessage}}>

                    </div>
                </Modal>
                {
              openMessaging ? <MessagingComponent   notes={communicationLogs.filter(note=>note.source_type === 'SmsProcess')}
                                                    customer={customer}
                                                    templates={systemTemplates.filter(item=>item.source_type === 'sms')}
                                                    sendMessage={sendSms}
                                                    closeComponent={()=>{
                                                        setOpenMessaging(false)
                                                    }}
                                                    error={error}
                                                    setError={setError}
                    />
                :
            openSentQuoteEmail ?
                <SendQuoteEmail templates={systemTemplates.filter(item=>item.source_type === 'email')}
                                onlyCustomer={!customer.deals?.length}
                                sendEmail={sendEmail} data={templateData} setShowSendQuoteEmail={()=>{
                                     setOpenSentQuoteEmail(false)
                                 }}
                />
                :
           <div className={'container-fluid debt-background pt-3'}>
            <EmailChat transformData={transformData}
                       isOpen={openEmailChat}
                       sendEmail={sendEmail}
                       templates={systemTemplates.filter(item=>item.source_type === 'email')}
                       data={customer}
                       setShowSendQuoteEmail={()=>{setOpenEmailChat(false)}}/>
            <div className={'d-flex justify-content-between mb-3 align-items-center'}>
                <CustomHeader lineHeight={'16px'} weight={'700'} color={'#000'} fontSize={'20px'}>Communication Log</CustomHeader>
                <Dropdown  isOpen={dropdownOpen} toggle={toggle}>
                    <CustomDropdownButton radius={'8px'}  backgroundColor={'#000'} color={'#fff'} caret size="lg">
                      + New Log
                    </CustomDropdownButton>
                    <DropdownMenu>
                        <DropdownItem onClick={openNewMessage}>
                            <div className={'d-flex g-5'}>
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'ic_message'}
                                    size={24}
                                />
                                <CustomHeader weight={'400'} color={'#74787E'} fontSize={'14px'}>
                                    New Message
                                </CustomHeader>
                            </div>
                          </DropdownItem>
                        <DropdownItem onClick={()=>{setOpenEmailChat(true)}}>
                            <div  className={'d-flex g-5'}>
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'ic_email'}
                                    size={24}
                                />
                                <CustomHeader weight={'400'} color={'#74787E'} fontSize={'14px'}>
                                    New Email
                                </CustomHeader>
                            </div>
                         </DropdownItem>
                    </DropdownMenu>
                </Dropdown>

            </div>
            <div className={'d-flex justify-content-between mb-3 flex-wrap'}>
                <div className={'d-flex g-10 mb-3 flex-wrap'}>
                    {
                        tabs.map((tab,index) => {
                            return (
                                <Fragment key={'n_'+index}>
                                    <RequiredItemsBadge  fontSize={'14px'} width={'100px'}  type={tab.key} onClick={()=> {
                                        setActiveCommunicationTab(tab.key);
                                    }
                                    } active={activeCommunicationTab === tab.key}>
                                        {tab.label}
                                    </RequiredItemsBadge>
                                </Fragment>
                            )
                        })
                    }
                </div>
                <div className={'d-flex g-10 debt-datePicker white-background'}>
                    <Picker
                        value={filter?.from}
                        placeholderText={'From'}
                        onChange={(date) => {
                            updateFilter({key:'from',value:date})
                        }}
                    />
                    <Picker
                        value={filter?.to}
                        placeholderText={'To'}
                        onChange={(date) => {
                            updateFilter({key:'to',value:date})
                        }}
                    />
                </div>
            </div>
                <div className={'table-container'}>
                    <StyledTable className={'table-borderless'}>
                        <thead className={'header-white-text'}>
                        <tr>
                            {keys.map((item,index)=>{
                                return  item.key !== 'view' &&  <Fragment key={index}>
                                    <StyledTableHeaderCell fontSize='14px' color={'#0000008C'}>
                                        {item.label}
                                    </StyledTableHeaderCell>
                                </Fragment>
                            })}

                        </tr>
                        </thead>
                        <tbody>
                        {tableData.length ?
                            tableData.map((item,index)=>{
                                return <CustomTableRow key={index}>
                                    {
                                        keys.map(({key}, keyIndex) => {
                                            return generateItem({item, index: `${index}_${keyIndex}`,key, itemIndex: index});
                                        })
                                    }
                                </CustomTableRow>

                            }) : null
                        }
                        </tbody>
                    </StyledTable>
                </div>
        </div>
         }
            </>

    );
}